// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"be518ec2","453":"9c082180","455":"c95ab38e","977":"9a3863a7"}[chunkId] + ".chunk.js";
};